import { withSearch } from '@elastic/react-search-ui';
import clsx from 'clsx';
import React from 'react';
import { createUseStyles } from 'react-jss';

import Layout from '../Layout';
import Loading from '../Loading';
import SearchItem from './SearchItem';
import SearchPageInfo from './SearchPageInfo';

const useStyles = createUseStyles((theme) => ({
  searchResult: {
    composes: 'flexColumn justifyCenter stretchSelf',
  },
  searchResultItems: {
    flex: 1,
    marginTop: -theme.spacing(10),
    marginBottom: -theme.spacing(10),
  },
  searchResultItem: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(10),
  },
}));

const SearchResult = ({ className, results, isLoading }) => {
  const classes = useStyles();

  if (!results) return null;
  // console.log('results: ', results.find(r => r.last_name.raw === 'Beaugendre')?.cie_lang_info.raw.map(j => JSON.parse(j)));
  // console.log('results: ', results.find(r => r.last_name.raw === 'Corlay')?.pers_about?.trim());
  // console.log('results 2: ', results.map(r => listStringToObject(r.cie_lang_info)));
  // console.log('results 2: ', results.map(r => listStringToObject(r.cie_lang_info).map(c => c.cie_iso)));

  // console.log('navigator', navigator.languages);
  
  return (
    <Layout className={clsx(classes.searchResult, className)}>
      <SearchPageInfo />
      {isLoading && <Loading isLoading={isLoading} />}
      <div className={classes.searchResultItems}>
        {results.map((result, index) => (
          <SearchItem 
            key={index}
            className={classes.searchResultItem} 
            result={result} 
          />
        ))}
      </div>
    </Layout>
  );
}

export default withSearch(({ results }) => ({ results }))(SearchResult);
